import create from 'zustand'
import config from './_config'
import store from '../../store'
import { Authentication } from './types'
import { State } from '../../store/types'
import { useMutation } from '../../internal'

type MutationData = {
  data: Authentication.Session
}

const useAuthenticate = (method: Authentication.Method) => {
  const mutation = useMutation()

  const useStore = create<State>(store)

  const { setTokens } = useStore()

  return mutation<never, Authentication.Authenticate<typeof method>>({
    method: 'POST',
    endpoint: config.endpoints[method],
    callback: (data: MutationData) => {
      if (!!data?.data?.token && !!data?.data?.refreshToken) {
        setTokens({
          token: data?.data?.token,
          refreshToken: data?.data?.refreshToken
        })
      }
    }
  })
}

export default useAuthenticate
